import { render, staticRenderFns } from "./ConfigurationImgType.vue?vue&type=template&id=0cce8bcd&scoped=true"
import script from "./ConfigurationImgType.vue?vue&type=script&lang=js"
export * from "./ConfigurationImgType.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationImgType.vue?vue&type=style&index=0&id=0cce8bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce8bcd",
  null
  
)

export default component.exports